var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-date-picker',{attrs:{"mode":"range","columns":2}})],1),_c('Card',[_c('ui-date-picker',{attrs:{"min-date":new Date(),"mode":"single"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }